import { Button } from '@predoc/cow';

interface FacesheetLoadErrorProps {
  onRetry?: () => void;
}

export const FacesheetLoadError = ({ onRetry }: FacesheetLoadErrorProps) => (
  <div className="flex min-h-0 flex-1 items-center justify-center">
    <div className="bg-background flex max-w-sm flex-col items-center gap-3 rounded-lg px-6 py-5 text-center shadow-sm">
      <p className="text-foreground text-sm font-medium">
        Failed to load facesheet.
      </p>
      {onRetry ? (
        <Button type="button" variant="outline" size="sm" onClick={onRetry}>
          Try again
        </Button>
      ) : null}
    </div>
  </div>
);
